import palette from 'theme/palette'
import { colors, makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  detachedBox: {
    backgroundColor: palette.primary.light,
    padding: '9px',
    borderRadius: '4px',
  },
  inactiveBox: {
    backgroundColor: palette.secondary.superLight,
    padding: '9px',
    borderRadius: '4px',
  },
  chipAnswered: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
    fontWeight: 700,
    height: '21px',
  },
  chipPending: {
    backgroundColor: colors.blue[100],
    color: colors.blue[800],
    fontWeight: 700,
    height: '21px',
  },
  chipInactive: {
    backgroundColor: colors.grey[100],
    color: colors.grey[800],
    fontWeight: 700,
    height: '21px',
  },
  linkButton: {
    color: colors.lightBlue[500],
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'transparent',
    },
  },
  linkText: {
    color: colors.lightBlue[500],
    fontWeight: 700,
  },
  endFormControl: {
    marginRight: 0,
  },
  boxStatus: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
    },
  },
}))

export default styles
